$(document).ready(function ($) {
    'use strict';

    // $('.preloader-wrapper').fadeOut();

    AOS.init({
        disable: function () {
            var ua = navigator.userAgent;
            return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
        },
        offset: 50,
        duration: 0,
        anchorPlacement: "bottom-bottom"
    });

    AOS.refresh();

    if (!String.prototype.startsWith) {
        Object.defineProperty(String.prototype, 'startsWith', {
            value: function(search, pos) {
                pos = !pos || pos < 0 ? 0 : +pos;
                return this.substring(pos, pos + search.length) === search;
            }
        });
    }

    /*
     * Modals - bootstrap based
     */

    $('.ccmt-modal-auto').modal({
        show: true,
        keyboard: false,
        backdrop: 'static'
    });

    $('.ccmt-modal-video')
        .on('show.bs.modal', function(event) {
            var button = $(event.relatedTarget);
            var videoId = button.data('videoId');

            var modal = $(this);
            modal
                .find('iframe')
                .attr('src', 'https://www.youtube.com/embed/' + videoId);
        })
        .on('hide.bs.modal', function() {
            var modal = $(this);
            modal.find('iframe').attr('src', '');
        });

    // Modals END

    $('#sf')
        .find('form')
        .submit(function(e) {
            e.preventDefault();
        });



    // Lock scrolling when the nav collapse menu is open
    $('.navbar-collapse').on('shown.bs.collapse', function() {
        $('body').addClass('overflow-hidden');
    });
    $('.navbar-collapse').on('hide.bs.collapse', function() {
        $('body').removeClass('overflow-hidden');
    });

    /* Search & filtering related functions */
    // Home filter
    $('#subjectcourse').change(function() {
        var val = $(this).val();
        var path = $(this).data('path');

        if (val === '') return;

        var url = path + '?subject=' + val;

        window.location.href = url;
    });

    const params = new URLSearchParams(window.location.search)

    // Other filters
    $('.filtercombo').change(function () {
        var value = $(this).val();
        if (value !== '') {
            if (params.has('header') && params.has('footer')) {
                location.search = 'subject=' + $(this).val() + "&header=0&footer=0";
            } else {
                location.search = 'subject=' + $(this).val();
            }
        } else {
            // Remove GET params
            if (params.has('header') && params.has('footer')) {
                window.location =
                    location.protocol + '//' + location.host + location.pathname + "?header=0&footer=0";
            } else {
                window.location =
                    location.protocol + '//' + location.host + location.pathname;
            }
        }
    });
    // Search & filtering END

    /*
        $('.language-switcher').click(function(e) {
            var lang = $(this).data("langid");

            if (!lang) return;

            var baseUrl = location.protocol + '//' + location.host + '/';
            var basePath = location.pathname.split("/").slice(2).join("/");

            window.location = baseUrl + lang + '/' + basePath;
        });
        */

    $('.language-switcher').click(function(e) {
        var lang = $(this)
            .data('langid')
            .toLowerCase();

        if (!lang) return;

        var baseUrl = location.protocol + '//' + location.host + '/';
        var basePath = location.pathname;
        if (lang == 'en') {
            if (
                basePath.startsWith('de/') ||
                basePath.startsWith('/de/') ||
                basePath.startsWith('/de')
            ) {
                basePath = location.pathname
                    .split('/')
                    .slice(2)
                    .join('/');
            } else {
                if (basePath.startsWith('/')) {
                    basePath = basePath.substring(1);
                }
            }
            lang = '';
        }
        if (lang == 'de') {
            if (
                basePath.startsWith('de/') ||
                basePath.startsWith('/de/') ||
                basePath.startsWith('/de')
            ) {
                basePath = location.pathname
                    .split('/')
                    .slice(2)
                    .join('/');
                lang = lang + '/';
            }
        }

        window.location = baseUrl + lang + basePath;
    });

    $('.dropdown-toggle').click(function () {
        if ($(this).next('.dropdown-menu').is(':visible')) {
            window.location = $(this).attr('href');
        }
    });

    // Force all external links to open in a new tab
    $(document.links)
        .filter(function () {
            return this.hostname != window.location.hostname;
        })
        .attr('target', '_blank');

    $('.timer').countTo({
        onComplete: function (value) {
            $('.count').addClass('d-none');
            $('.countend').removeClass('d-none');
        },
        formatter: function (val, opt) {
            var rest = $(this).data('rest');
            val = parseFloat(val);
            var num = val.toFixed(opt.decimals);

            return num + (rest ? rest : '');
        }
    });

    $('.share').click(function() {
        var links = $(this)
            .closest('.card')
            .find('.sharelinks');

        if (links.length === 0) {
            var links = $(this).closest('.random-card').find('.sharelinks');
        }

        // Hide all other buttons if opening a new one
        if (links.is(':hidden')) $('.sharelinks').hide();

        links.toggle();
    });

   $('[data-toggle="tooltip"]').tooltip();

    // Search modal
    $('a[href="#search"]').on('click', function(event) {
        event.preventDefault();
        $('#search').addClass('open');
        $('#search > form > input[type="search"]').focus();
    });

    $('#search, #search button.close').on('click keyup', function(event) {
        if (
            event.target == this ||
            event.target.className == 'close' ||
            event.keyCode == 27
        ) {
            $(this).removeClass('open');
        }
    });


    // Rotate the "+" button when opening and closing
    $('.collapse').on('show.bs.collapse', function() {
        $(this)
            .parent()
            .find('.fa-plus')
            .toggleClass('rotate');
    });

    $('.collapse').on('hide.bs.collapse', function() {
        $(this)
            .parent()
            .find('.fa-plus')
            .toggleClass('rotate');
        $(this)
            .parent()
            .find('button')
            .blur();
    });

    // Searchbox
    //var submitIcon = $('.searchbox-icon');
    //var inputBox = $('.searchbox-input');
    //var searchBox = $('.searchbox');
    //var isOpen = false;

    //submitIcon.click(function() {
    //    if (isOpen) {
    //        /*if (inputBox.val().trim() != "")
    //                         inputBox.val(inputBox.val().trim());*/
    //        if (inputBox.val()) {
    //            $('.searchbox-icon').css('display', 'block');
    //            searchBox.submit();
    //        } else {
    //            searchBox.removeClass('searchbox-open');
    //            inputBox.focusout();
    //            isOpen = false;
    //        }
    //    } else {
    //        searchBox.addClass('searchbox-open');
    //        inputBox.focus();
    //        isOpen = true;
    //    }
    //});

    /* Remove duplicate slider element */
    $(".programmes-slider-d").first().remove();
    $(".programmes-slider-m").last().remove();

    /* TinySlider sliders */
    if (document.querySelector('.mainSlider')) {
        tns({
            container: '.mainSlider-slider',
            items: 1,
            mode: 'gallery',
            slideBy: 'page',
            speed: 500,
            autoplay: false,
            autoplayButtonOutput: false,
            //autoplayTimeout: 7000,
            controls: true,
            //loop: false,
            mouseDrag: true,
            nav: true,
            //lazyload: true,
            //lazyloadSelector: '.mainSlider-image',
            prevButton: '.tns-prev',
            nextButton: '.tns-next',
            responsive: {              
                768: {
                    autoplay: true,
                    autoplayTimeout: 7000,
                    controls: false,
                    loop: true,
                }               
            }           
        });
    }

    if (document.querySelector('.testimonial-slider')) {
        tns({
            container: '.testimonial-slider',
            items: 1,
            slideBy: 'page',
            speed: 500,
            autoplay: false,
            autoplayButtonOutput: false,
            autoplayTimeout: 7000,
            controls: false,
            loop: true,
            mouseDrag: true,
            nav: false,
            responsive: {
                520: {
                    nav: true
                }
            }
        });
    }

    if (document.querySelector('.logoSlider')) {
        tns({
            container: '.logoSlider-slider',
            items: 1,
            slideBy: 1,
            nav: false,
            controls: false,
            autoplay: true,
            autoplayButtonOutput: false,
            loop: true,
            mouseDrag: true,
            lazyload: true,            
            responsive: {
                1200: {
                    items: 3
                },
                768: {
                    items: 3
                },
                576: {
                    items: 2
                }
            }
        });
    }

    if (document.querySelector('.blog-slider')) {
        tns({
            container: '.blog-slider-slider',
            items: 1,
            slideBy: 'page',
            speed: 5000,
            autoplay: false,
            autoplayButtonOutput: false,
            autoplayTimeout: 5000,
            controls: true,
            loop: false,
            mouseDrag: true,
            nav: true,
            prevButton: '.tns-prev',
            nextButton: '.tns-next'
        });
    }

    if (document.querySelector('.text-slider')) {
        tns({
            container: '.text-slider-slider',
            items: 1,
            slideBy: 'page',
            speed: 1000,
            autoplay: false,
            autoplayButtonOutput: false,
            autoplayTimeout: 5000,
            controls: true,
            loop: false,
            mouseDrag: true,
            nav: true,
            lazyload: true,
            lazyloadSelector: '.text-slider-image',
            prevButton: '.tns-prev',
            nextButton: '.tns-next'
        });
    }

    if (document.querySelector('.programmes-slider-d')) {
        tns({
            container: '.programmes-slider-item-d',
            items: 1,
            edgePadding: -5,
            speed: 500,
            controls: true,
            loop: false,
            mouseDrag: true,
            nav: false,
            rewind: true,
            prevButton: '.tns-prev-d',
            nextButton: '.tns-next-d',
            responsive: {
                1200: {
                    items: 3,                   
                },
                768: {
                    items: 2
                },
                576: {
                    items: 1
                }
            },
        });
    }

    if (document.querySelector('.programmes-slider-m')) {
        tns({
            container: '.programmes-slider-item-m',
            items: 1,
            edgePadding: -5,
            speed: 500,
            controls: true,
            loop: false,
            mouseDrag: true,
            nav: false,
            rewind: true,
            prevButton: '.tns-prev-m',
            nextButton: '.tns-next-m',
            responsive: {
                1200: {
                    items: 3,
                },
                768: {
                    items: 2
                },
                576: {
                    items: 1
                }
            },
        });
    }
/* TinySlider sliders END */

/* Partners logo slider */

if (document.querySelector('.scrolling-logo-wall__logos')) {
    var slideItem = $('#logoCount').val();
    var sCount = 1;

    if (slideItem <= 6) {
        sCount = 1;
    }
    else if (slideItem > 6 && slideItem <= 12) {
        sCount = 2;
    }
    else {
        sCount = 3;
    }

    $('.scrolling-logo-wall__logos').slick({
        lazyload:"progressive",
        rows: sCount,
        speed: 3000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        draggable: false,
        accessibility: false,
    });
}

/* Partners logo slider END */

/* Square figure to rounded */
    $(function () {
        var roundedNavigation = (function () {
            "use strict";
            const roundedSquare = function roundedSquare() {
                $(".tns-nav>button").addClass("rounded-circle");
                $(".tns-nav-active>button").addClass("rounded-circle");
            };

            return {
                roundedSquare: roundedSquare
            };
        })();
        roundedNavigation.roundedSquare();
    });

/* Expand and collapse */
    $(function () {
        var changeClass = (function () {
            "use strict";
            const toggleAction = function toggleAction(event) {
                $("i .fa .fa-angle-up").toggleClass("fa fa-angle-down");
            };

            return {
                toggleAction: toggleAction
            };
        })();
        changeClass.toggleAction();
    });


    // Append .background-image-holder <img>'s as CSS backgrounds
    $('.background-image-holder').each(function() {
        var imgSrc = $(this)
            .children('img')
            .attr('src');
        $(this).css('background', 'url("' + imgSrc + '")');
        $(this)
            .children('img')
            .hide();
        $(this).css('background-position', 'initial');
    });

    // Fade in background images
    setTimeout(function() {
        $('.background-image-holder').each(function() {
            $(this).addClass('fadeIn');
        });
    }, 200);

    // Prepare embedded video modals
    $('iframe[data-provider]').each(function() {
        var provider = jQuery(this).attr('data-provider');
        var videoID = jQuery(this).attr('data-video-id');
        var autoplay = jQuery(this).attr('data-autoplay');
        var vidURL = '';

        if (provider == 'vimeo') {
            vidURL =
                'https://player.vimeo.com/video/' +
                videoID +
                '?badge=0&title=0&byline=0&title=0&autoplay=' +
                autoplay;
            $(this).attr('data-src', vidURL);
        } else if (provider == 'youtube') {
            vidURL =
                'https://www.youtube.com/embed/' +
                videoID +
                '?showinfo=0&autoplay=' +
                autoplay;
            $(this).attr('data-src', vidURL);
        } else {
            console.log(
                'Only Vimeo and Youtube videos are supported at this time'
            );
        }
    });

    // Multipurpose Modals

    jQuery('.ccmt_modal[modal-link]').remove();

    if ($('.ccmt_modal').length && !jQuery('.modal-screen').length) {
        // Add a div.modal-screen if there isn't already one there.
        var modalScreen = jQuery('<div />')
            .addClass('modal-screen')
            .appendTo('body');
    }

    jQuery('.ccmt_modal').click(function() {
        jQuery(this).addClass('modal-acknowledged');
    });

    jQuery(document).on(
        'wheel mousewheel scroll',
        '.ccmt_modal, .modal-screen',
        function (evt) {
            $(this).get(0).scrollTop += evt.originalEvent.deltaY;
        }
    );

    $('.modal-container:not([modal-link])').each(function(index) {
        if (jQuery(this).find('iframe[src]').length) {
            jQuery(this)
                .find('.ccmt_modal')
                .addClass('iframe-modal');
            var iframe = jQuery(this).find('iframe');
            iframe.attr('data-src', iframe.attr('src'));
            iframe.attr('src', '');
        }
        jQuery(this)
            .find('.btn-modal')
            .attr('modal-link', index);

        // Only clone and append to body if there isn't already one there
        if (!jQuery('.ccmt_modal[modal-link="' + index + '"]').length) {
            jQuery(this)
                .find('.ccmt_modal')
                .appendTo('body')
                .attr('modal-link', index)
                .prepend(jQuery('<i class="fa fa-times close-modal">'));
        }
    });

    $('.btn-modal')
        .unbind('click')
        .click(function() {
            var linkedModal = jQuery(
                    '.ccmt_modal[modal-link="' +
                        jQuery(this).attr('modal-link') +
                        '"]'
                ),
                autoplayMsg = '';
            jQuery('.modal-screen').toggleClass('reveal-modal');
            if (linkedModal.find('iframe').length) {
                if (linkedModal.find('iframe').attr('data-autoplay') === '1') {
                    var autoplayMsg = '&autoplay=1';
                }
                linkedModal
                    .find('iframe')
                    .attr(
                        'src',
                        linkedModal.find('iframe').attr('data-src') +
                            autoplayMsg
                    );
            }
            if (linkedModal.find('video').length) {
                linkedModal
                    .find('video')
                    .get(0)
                    .play();
            }
            linkedModal.toggleClass('reveal-modal');
            return false;
        });

    // Autoshow modals

    $('.ccmt_modal[data-time-delay]').each(function() {
        var modal = $(this);
        var delay = modal.attr('data-time-delay');

        if (delay > 1000) {
            modal.prepend($('<i class="fa fa-times close-modal">'));
            if (typeof modal.attr('data-cookie') != 'undefined') {
                if (!mr_cookies.hasItem(modal.attr('data-cookie'))) {
                    setTimeout(function () {
                        modal.addClass('reveal-modal');
                        $('.modal-screen').addClass('reveal-modal');
                    }, delay);
                }
            } else {
                setTimeout(function () {
                    modal.addClass('reveal-modal');
                    $('.modal-screen').addClass('reveal-modal');
                }, delay);
            }
        }
    });

    // Exit modals
    $('.ccmt_modal[data-show-on-exit]').each(function() {
        var modal = $(this);
        var exitSelector = $(modal.attr('data-show-on-exit'));
        // If a valid selector is found, attach leave event to show modal.
        if ($(exitSelector).length) {
            modal.prepend($('<i class="fa fa-times close-modal">'));
            $(document).on('mouseleave', exitSelector, function() {
                if (!$('body .reveal-modal').length) {
                    if (typeof modal.attr('data-cookie') !== typeof undefined) {
                        if (!mr_cookies.hasItem(modal.attr('data-cookie'))) {
                            modal.addClass('reveal-modal');
                            $('.modal-screen').addClass('reveal-modal');
                        }
                    } else {
                        modal.addClass('reveal-modal');
                        $('.modal-screen').addClass('reveal-modal');
                    }
                }
            });
        }
    });

    // Autoclose modals

    $('.ccmt_modal[data-hide-after]').each(function() {
        var modal = $(this);
        var delay = modal.attr('data-hide-after');
        if (typeof modal.attr('data-cookie') != 'undefined') {
            if (!mr_cookies.hasItem(modal.attr('data-cookie'))) {
                setTimeout(function() {
                    if (!modal.hasClass('modal-acknowledged')) {
                        modal.removeClass('reveal-modal');
                        $('.modal-screen').removeClass('reveal-modal');
                    }
                }, delay);
            }
        } else {
            setTimeout(function() {
                if (!modal.hasClass('modal-acknowledged')) {
                    modal.removeClass('reveal-modal');
                    $('.modal-screen').removeClass('reveal-modal');
                }
            }, delay);
        }
    });

    jQuery('.close-modal:not(.modal-strip .close-modal)')
        .unbind('click')
        .click(function () {
            $("body").css("overflow-y", "auto");
            var modal = jQuery(this).closest('.ccmt_modal');

            if (modal.find('.ccmt-modal__cookie input')[0]) {
                var cookiesEnabled = modal.find('.ccmt-modal__cookie input')[0]
                    .checked;
            }

            modal.toggleClass('reveal-modal');
            if (
                cookiesEnabled &&
                typeof modal.attr('data-cookie') !== 'undefined'
            ) {
                mr_cookies.setItem(modal.attr('data-cookie'), 'true', Infinity);
            }
            if (modal.find('iframe').length) {
                modal.find('iframe').attr('src', '');
            }
            jQuery('.modal-screen').removeClass('reveal-modal');
        });

    /* Courses Form toogle */


    jQuery('.sidebar-form.border i')
        .unbind('click')
        .click(function () {
            jQuery(this).parent().find('div').first().click();
        });

    jQuery('.modal-screen')
        .unbind('click')
        .click(function () {
            $("body").css("overflow-y", "auto");
            if (jQuery('.ccmt_modal.reveal-modal').find('iframe').length) {
                jQuery('.ccmt_modal.reveal-modal')
                    .find('iframe')
                    .attr('src', '');
            }
            jQuery('.ccmt_modal.reveal-modal').toggleClass('reveal-modal');
            jQuery(this).toggleClass('reveal-modal');
        });

    jQuery('.btn.btn-apply')
        .unbind('click')
        .click(function (e) {
            e.preventDefault();
            var modal = jQuery(this).closest('.ccmt_modal').find('.close-modal');
            var openform = jQuery('.sidebar-form.border').children().first();
            modal.click();
            if (!openform.parent().hasClass('opened')) { openform.click() };
        });

    jQuery(document).keyup(function (e) {
        if (e.keyCode == 27) {
            // escape key maps to keycode `27`
            if (jQuery('.ccmt_modal').find('iframe').length) {
                jQuery('.ccmt_modal')
                    .find('iframe')
                    .attr('src', '');
            }
            jQuery('.ccmt_modal').removeClass('reveal-modal');
            jQuery('.modal-screen').removeClass('reveal-modal');
        }
    });

    // Modal Strips

    jQuery('.modal-strip').each(function() {
        if (!jQuery(this).find('.close-modal').length) {
            jQuery(this).append(jQuery('<i class="fa-times fa close-modal">'));
        }
        var modal = jQuery(this);

        if (typeof modal.attr('data-cookie') != 'undefined') {
            if (!mr_cookies.hasItem(modal.attr('data-cookie'))) {
                setTimeout(function() {
                    modal.addClass('reveal-modal');
                }, 1000);
            }
        } else {
            setTimeout(function() {
                modal.addClass('reveal-modal');
            }, 1000);
        }
    });

    jQuery('.modal-strip .close-modal').click(function() {
        var modal = jQuery(this).closest('.modal-strip');
        if (typeof modal.attr('data-cookie') != 'undefined') {
            mr_cookies.setItem(modal.attr('data-cookie'), 'true', Infinity);
        }
        jQuery(this)
            .closest('.modal-strip')
            .removeClass('reveal-modal');
        return false;
    });

    // Modal Modeless

    jQuery('.modal-modeless').each(function() {
        if (!jQuery(this).find('.close-modal').length) {
            jQuery(this).append(jQuery('<i class="fa-times fa close-modal">'));
        }
        var modal = jQuery(this);

        if (typeof modal.attr('data-cookie') != 'undefined') {
            if (!mr_cookies.hasItem(modal.attr('data-cookie'))) {
                setTimeout(function() {
                    modal.addClass('reveal-modal');
                }, 1000);
            }
        } else {
            setTimeout(function() {
                modal.addClass('reveal-modal');
            }, 1000);
        }
    });

    jQuery('.modal-modeless .close-modal').click(function() {
        var modal = jQuery(this).closest('.modal-modeless');
        if (typeof modal.attr('data-cookie') != 'undefined') {
            mr_cookies.setItem(modal.attr('data-cookie'), 'true', Infinity);
        }
        jQuery(this)
            .closest('.modal-modeless')
            .removeClass('reveal-modal');
        return false;
    });

    $('.yt-video').each(function() {
        var video = $(this);
        var source =
            'https://img.youtube.com/vi/' +
            video.data('embed') +
            '/sddefault.jpg';

        var image = new Image();
        image.src = source;
        image.alt = 'Youtube Thumbnail';
        image.addEventListener('load', function() {
            video.prepend(image);
        });

        video.click(function() {
            var iframe = document.createElement('iframe');

            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute(
                'allow',
                'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
            );
            iframe.setAttribute(
                'src',
                'https://www.youtube.com/embed/' +
                    video.data('embed') +
                    '?rel=0&showinfo=0&autoplay=1'
            );

            $(this)
                .siblings('.yt-overlay')
                .hide();
            $(this).html('');
            $(this).prepend(iframe);
        });
    });

    /*
     * Back to top button and Showing Pop-Up after half screen scrolled
     */
    var isScrolled = false;

    $(window).scroll(function () {
        var backToTopButton = $('#back-to-top');
        var popup = jQuery('.course-popup');

        var scrollDistance = $(this).scrollTop();
        var showDistance = window.innerHeight / 2;

        if (scrollDistance > showDistance) {
            backToTopButton.fadeIn(150);
            if (popup.data('scroll') === "True" && !isScrolled) {
                popup.addClass('reveal-modal');
                jQuery('.modal-screen').addClass('reveal-modal');
                isScrolled = true;
            }
        }
        else backToTopButton.fadeOut(150);
    });

    $('#back-to-top').click(function () {
        window.scroll(0, 0);
    });
    /* Back to top button END */

    /*
     * Visa Requirements dropdown
     */
    $('#visa-select-country').change(function() {
        var select = $(this);
        var selectedCountry = select.find(':selected');

        $('#visa-block').removeClass('d-none');

        // Displays the country name
        $('#visa-selected-country').html(select.val());

        var needsVisa = selectedCountry.data('visa') == 'True';
        var msgYes = $('#visa-msg-yes');
        var msgNo = $('#visa-msg-no');
        var customElement = $('#visa-msg-custom');
        var customMessage = selectedCountry.data('msg');

        // Yes / No message
        if (needsVisa) {
            $('#visa-yes').show(0);
            $('#visa-no').hide(0);
        } else {
            $('#visa-yes').hide(0);
            $('#visa-no').show(0);
        }

        msgYes.hide(0);
        msgNo.hide(0);
        customElement.hide(0);

        // Visa Requirements main body
        if (customMessage) {
            customElement.show(0);
            customElement.html(customMessage);
        } else if (needsVisa) {
            $('#visa-msg-yes').show(0);
        } else {
            $('#visa-msg-no').show(0);
        }
    });
    /* Visa Requirements dropdown END */

    cssVars({});

    /*Open Pop-Up when Idle Timer passed*/
    if (jQuery('.course-popup').length > 0) {
        var idleTime = 0;
        var inactivityTimer = jQuery('.course-popup').data('inactivity') * 60000;

        function timerIncrement() {
            idleTime += 60000;
            if (idleTime === inactivityTimer) {
                jQuery('.course-popup').addClass('reveal-modal');
                jQuery('.modal-screen').addClass('reveal-modal');
            }
        }

        var idleInterval = setInterval(timerIncrement, 60000);

        jQuery(this).mousemove(function () {
            idleTime = 0;
        });
        jQuery(this).keypress(function () {
            idleTime = 0;
        });
    }


    /* SalesForce form appearance manipulation */
    $(function () {
        var salesForceForm = (function () {
            "use strict";
            const pillFormButton = function pillFormButton() {
                var checkExists = setInterval(function () {
                    if ($('form.jForm').length) {
                        $('.jForm__button').parent().addClass("text-center");
                        $('.jForm__button').addClass("rounded-pill");
                        if (window.innerWidth < 700) {
                            $('.jForm .jForm__button[type="submit"]').css("width", "40%");
                        }
                        clearInterval(checkExists);
                    }
                }, 100);
            };
            return {
                pillFormButton: pillFormButton,
            };
        })();
        salesForceForm.pillFormButton();
    });

    /* Manipulation Content buttons */
    $(function () {
        var changeTo = (function () {
            "use strict";
            const pilledButton = function pilledButton() {
                $('.btn-primary-rte').addClass("rounded-pill");
                $('.btn-secondary-rte').addClass("rounded-pill");
            };
            return {
                pilledButton: pilledButton,
            };
        })();
        changeTo.pilledButton();
    });

    /* Manipulation Toggle arrows up and down */
    $(function () {
        var toggleTo = (function () {
            "use strict";
            const upOrDown = function upOrDown() {
                $(".nav-link").on("click", (function (t) {
                    var e = $(t.target).closest(".nav-item").find(".show");
                    $(this).children(".fa").toggleClass("fa-angle-down fa-angle-up");
                }));
            };
            return {
                upOrDown: upOrDown,
            };
        })();
        toggleTo.upOrDown();
    });

    /* Change the background color in mobile */
    $(function () {
        var navMobile = (function () {
            "use strict";
            const changeBackgroundColor = function changeBackgroundColor() {
                $("button.navbar-toggler").click(function (t) {
                    var e = $(t.target).closest("#myTogglerNav").find(".show");
                    $(".container-fluid.site-nav-container").toggleClass("mobile-bg-transparent mobile-bg-gray");
                    $(".navbar-collapse").toggleClass("mobile-collapse-bg mobile-expand-bg");
                    $(".container-fluid.site-nav-container.desktop").toggleClass("mobile-bg-gray");
                    $(".backToMainMenu").click();
                });
            };
            return {
                changeBackgroundColor: changeBackgroundColor,
            };
        })();
        navMobile.changeBackgroundColor();
    });

    /* Salesforce form placeholder manipulation */
    $(function () {
        var salesforceForm = (function () {

            const activeInputText = function activeInputText() {
                var checkExists = setInterval(function () {
                    if ($('form.jForm').length) {

                        $("input.jForm__input").focusin(function () {
                            $(this).parent().parent().addClass("active");
                        });

                        $("input.jForm__input").focusout(function () {

                            if ($(this).val() == "" && $(this).attr("type")!="tel") {
                                $(this).parent().parent().removeClass("active");
                            }
                        });

                        $("textarea.jForm__textarea").focusin(function () {

                            $(this).parent().parent().addClass("active");
                        });

                        $("textarea.jForm__textarea").focusout(function () {
                            if ($(this).val() == "") {
                                $(this).parent().parent().removeClass("active");
                            }
                        });

                        clearInterval(checkExists);
                    }

                }, 100);
            };
            return {
                activeInputText: activeInputText,
            };
        })();

        salesforceForm.activeInputText();

        $('.btn-modal').on('click',function () {
            if($('.ccmt_modal').hasClass('reveal-modal')) {
                salesforceForm.activeInputText();
            }
        });
    });

    /* Manipulation Toggle arrows up and down for desktop navigation */
    $(function () {
        var hoverTo = (function () {
            "use strict";
            const upOrDown = function upOrDown() {
                $(".nav-item").hover(function () {
                    //$(this).children(".fa").toggleClass("fa-angle-down fa-angle-up");
                });
            };
            return {
                upOrDown: upOrDown,
            };
        })();
        hoverTo.upOrDown();
    });

    /* Manipulation scroll up and down to show the keyfacts buttons */
    $(function () {
        var scroll = (function () {
            "use strict";

            function getOffset(el) {
                var _x = 0;
                var _y = 0;
                while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
                    _x += el.offsetLeft - el.scrollLeft;
                    _y += el.offsetTop - el.scrollTop;
                    el = el.offsetParent;
                }
                return { top: _y, left: _x };
            }

            const upDown = function upDown() {

                var keyfactButtons = getOffset(document.getElementById("keyfact-buttons")).top;
                if (((keyfactButtons - window.scrollY) - (window.innerHeight) < 0)) {
                    $("#bottom-buttons").css("z-index", "1030");
                }
                else {
                    $("#bottom-buttons").css("z-index", "-1");
                }
                window.onscroll = function (e) {
                    if (((keyfactButtons - window.scrollY) - (window.innerHeight) < 0)) {
                        $("#bottom-buttons").css("z-index", "1030");
                    }
                    else {
                        $("#bottom-buttons").css("z-index", "-1");
                    }
                };
            };
            return {
                upDown: upDown,
            };
        })();
        scroll.upDown();
    });


    /* Manipulation mobile burger navigation menu */
    $(function () {
        var burgerMobileMenu = (function () {
            "use strict";
            const openClose = function openClose() {
                $('button.navbar-toggler').on('click', function () {
                    $(".nav-icon.show").toggleClass("open close", "");
                    $(".container-fluid.site-nav-container").toggleClass("mobile-bg-transparent", "bg-top-nav");
                    $("div.container-fluid.desktop div.col-2").toggleClass("d-none", "d-block");

                });
            };
            return {
                openClose: openClose,
            };
        })();
        burgerMobileMenu.openClose();
    });

    ///* Manipulation search box open close  */
    //$(function () {
    //    var searchBox = (function () {
    //        "use strict";
    //        const openClose = function openClose() {
    //            var submitIcon = $('.searchbox-icon-st');
    //            var inputBox = $('.searchbox-input-st');
    //            var searchBox = $('.searchbox');
    //            var isOpen = false;

    //            submitIcon.click(function () {

    //                if (isOpen) {
    //                    $("#contact-nav").removeClass("open-search");
    //                    if (inputBox.val()) {
    //                        $('.searchbox-icon-st').css('display', 'block');
    //                        searchBox.submit();
    //                    } else {
    //                        searchBox.removeClass('searchbox-open-st');
    //                        inputBox.focusout();
    //                        isOpen = false;
    //                    }
    //                } else {
    //                    $("#contact-nav").addClass("open-search");
    //                    searchBox.addClass('searchbox-open-st');
    //                    inputBox.focus();
    //                    isOpen = true;
    //                }
    //            });

    //        };
    //        return {
    //            openClose: openClose,
    //        };
    //    })();
    //    searchBox.openClose();
    //});


    $(function () {
        var navigationSticky = (function () {
            "use strict";

            const show = function show() {
                const position = 100;

                window.onscroll = function (e) {

                    if (position < window.scrollY) {
                        $(".site-nav.non-sticky").addClass("sticky");
                        $(".site-nav.sticky").removeClass("non-sticky");

                        //$(".site-nav.non-sticky-mobile").addClass("sticky-mobile");
                        //$(".site-nav.sticky-mobile").removeClass("non-sticky-mobile");
                    }
                    else {
                        $(".site-nav.sticky").addClass("non-sticky");
                        $(".site-nav.non-sticky").removeClass("sticky");

                        //$(".site-nav.sticky-mobile").addClass("non-sticky-mobile");
                        //$(".site-nav.non-sticky-mobile").removeClass("sticky-mobile");
                    }
                };
            };
            return {
                show: show,
            };
        })();
        navigationSticky.show();
    });

/* Manipulation Mobile navigation show submenu */
    $(function () {
        var mobileNavigation = (function () {
            "use strict";

            const show = function show() {
                $(".fa.fa-angle-right.arrow-mobile").click(function () {
                    $(this).next().addClass("active");
                });
            };
            return {
                show: show,
            };
        })();
        mobileNavigation.show();
    });

/* Manipulation  Mobile navigation show submenu Bak  */
    $(function () {
        var mobileNavigation = (function () {
            "use strict";

            const backto = function backto() {
                $(".backToMainMenu").click(function () {
                    $(this).parent().parent().parent().parent().removeClass("active");
                });
            };
            return {
                backto: backto,
            };
        })();
        mobileNavigation.backto();
    });

/* Manipulation to remove tooltip */
    $(function () {
        var tooltip = (function () {
            "use strict";

            const remove = function remove() {
                $("a.nav-link").hover(function () {
                    $(this).attr("tooltip-data", $(this).attr("title"));
                    $(this).removeAttr("title");
                }, function () {
                    $(this).attr("title", $(this).attr("tooltip-data"));
                    $(this).removeAttr("tooltip-data");
                });

            };
            return {
                remove: remove,
            };
        })();
        tooltip.remove();
    });

    /* Manipulation for the search button */
    $(function () {
        var search = (function () {
            "use strict";

            const toggleTo = function toggleTo() {
                $("input.form-control").focusin(function () {
                    $("#src-button-mobile").children().css("color", "#252629");
                });
                $("input.form-control").focusout(function () {
                    $("#src-button-mobile").children().css("color", "#FFF");
                });
            };
            return {
                toggleTo: toggleTo,
            };
        })();
        search.toggleTo();
    });



});

document.addEventListener("DOMContentLoaded", function () {
    formsEdology();
    var form = document.querySelector(".main-form__salesforce .jForm");

    if (form) {

        overrideLegalNotices();

    } else {

        var parent = document.querySelector(".main-form__salesforce");

        if (parent) {
            // Set Callback function to be executed when observer find jForm loaded asynchronously
            var observer = new MutationObserver(function (mutations) {

                mutations.forEach(function (mutation) {

                    for (var i = 0; i < mutation.addedNodes.length; i++) {
                        var node = mutation.addedNodes[i];

                        if (node.classList !== undefined && node.classList.contains("jForm")) {

                            overrideLegalNotices();

                            observer.disconnect();
                        }
                    }
                });
            });

            observer.observe(parent, {
                childList: true,
                subtree: true
            });
        }
    }
});

function formsEdology() {
  var checkExist = setInterval(function() {
    if ($('#sf .jForm .jForm__input').length !== 0 && $('#sf .jForm .jForm__textarea').length !== 0) {
      setTimeout(() => {
        
        $("input.jForm__input").attr("placeholder", "");
        $("textarea.jForm__textarea").attr("placeholder", "");
        $("select.jForm__input").parent().parent().addClass("active");
        $("input.jForm__input").focusin(function () {
          $(this).parent().parent().addClass("active");
      });

      $("input.jForm__input").focusout(function () {
        if ($(this).val() == "" && $(this).attr("type")!="tel") {
          $(this).parent().parent().removeClass("active");
        }
      });

      $("textarea.jForm__textarea").focusin(function () {
        $(this).parent().parent().addClass("active");
      });

      $("textarea.jForm__textarea").focusout(function () {
        if ($(this).val() == "") {
          $(this).parent().parent().removeClass("active");
        }
      });

      }, 1000);

      clearInterval(checkExist);
    }
 }, 100);

 setTimeout(() => {
  // $("input.jForm__input").attr("placeholder", "");
  // $("textarea.jForm__textarea").attr("placeholder", "");
  // $("select.jForm__input").parent().parent().addClass("active");
 }, 5000);

}

function overrideLegalNotices() {
    var forms = document.querySelectorAll(".main-form__salesforce");

    [...forms].forEach((form) => {
        if (form.querySelector(".jForm__text") && form.querySelector(".legal-notices")) {
            form.querySelector(".jForm__text").textContent = "";
            form.querySelector(".jForm__text").appendChild(form.querySelector(".legal-notices"));
        }
    });

    $("input.jForm__input").attr("placeholder", "");
    $("textarea.jForm__textarea").attr("placeholder", "");
    $("select.jForm__input").parent().parent().addClass("active");
}

// floating link
document.addEventListener('scroll', function(e) {
    var element = document.getElementById("floatingLink");
    if (typeof (element) != 'undefined' && element != null) {
        // Exists.
        if (window.innerWidth > 992) {
            if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
                element.classList.add("scroll-down");
            } else {
                element.classList.remove("scroll-down");
            }
        }
    }
});

// side nav enquire form
var enquireForm = document.getElementById("enquireForm");
var overlay = document.getElementById("enquireFormOverlay");

var element = document.getElementById('sideNav');
if (typeof (element) != 'undefined' && element != null) {
    // Exists.
    document.getElementById("sideNav").addEventListener("click", function (e) {
        e.preventDefault();
        enquireForm.classList.add("active");
        overlay.classList.add("active");
    });

    document.getElementById("close").addEventListener("click", function (e) {
        enquireForm.classList.remove("active");
        overlay.classList.remove("active");
    });

    document.getElementById("enquireFormOverlay").addEventListener("click", function (e) {
        enquireForm.classList.remove("active");
        overlay.classList.remove("active");
    });
}

// Programs collapse
$('.collapse').on('shown.bs.collapse', function (e) {
    var $list = $(this).closest('.accordion-list');
    if ($(window).width() <= 768 && $list.length > 0) {
        $('html,body').animate({
            scrollTop: $list.offset().top - 100
        }, 500);
    }   
});

// Manipulation desktop navigation

$('li.angle-toggle').on('click', function (e) {

    if (!$('ul.level-1-children').first().hasClass('show')) {
        $('ul.level-1-children').first().addClass('show');
    }
   
    if ($(this).children(".level-2-children").hasClass('show')) {
        var $ul = $(this).children(".nav-item.dropdown>ul.level-2-children").first();
        $ul.toggleClass("show");
        var $a = $(this).children(".nav-item.dropdown>i.fa").first();
        $a.toggleClass("fa-angle-up fa-angle-down");
    }
    else {
        $(".level-2-children").removeClass('show');
        $(".nav-item.dropdown>i.fa").removeClass("fa-angle-up");
        $(".nav-item.dropdown>i.fa").removeClass("fa-angle-down");
        $(".nav-item.dropdown>i.fa").addClass("fa-angle-down");

        var $subMenu = $(this).children(".level-2-children").first();
        $subMenu.toggleClass('show');

        var $a = $(this).children(".nav-item.dropdown>i.fa").first();
        $a.toggleClass("fa-angle-down fa-angle-up");
    }
    
});

$('ul.level-1-children').mouseout(function () {
    var $ulStyle = $(this).css("display");
    if ($ulStyle !== "block") {
        if (!$(this).siblings(".level-2-children").hasClass('show')) {
            $(this).siblings(".level-2-children").first().find('.show').removeClass("show");
        }
        if (!$(this).hasClass('show')) {
            $(this).first().find('.show').removeClass("show");
        }

        var $a = $(".nav-item.dropdown>i.fa-angle-up").first();
        $a.toggleClass("fa-angle-up fa-angle-down");
    }

});


$('li.level-0').mouseenter(function () {
    if ($('ul.level-1-children').first().hasClass('show')) {
        $('ul.level-1-children').first().removeClass('show');
        $(".level-2-children").removeClass('show');
        $(".nav-item.dropdown>i.fa").removeClass("fa-angle-up");
        $(".nav-item.dropdown>i.fa").removeClass("fa-angle-down");
        $(".nav-item.dropdown>i.fa").addClass("fa-angle-down");
    }
   
});


$('.mainSlider').on('click', function (e) {
    if ($('ul.level-1-children').first().hasClass('show')) {
        $('ul.level-1-children').first().removeClass('show');
        $(".level-2-children").removeClass('show');
        $(".nav-item.dropdown>i.fa").removeClass("fa-angle-up");
        $(".nav-item.dropdown>i.fa").removeClass("fa-angle-down");
        $(".nav-item.dropdown>i.fa").addClass("fa-angle-down");
    }
});

function myFunction() {

    setTimeout(function () {
        if ($("div").hasClass("reveal-modal")) {
            $("body").css("overflow-y", "hidden");
        }
    }, 500);
}

$(document).ready(() => {
    // SEARCH MODAL FORM
    var searchFormModal = document.getElementById("searchModalForm");
    var overlay = document.getElementById("searchModalFormOverlay");


    const hideOverlappingElements = () => {
        var floatingLinkEl = document.getElementById('floatingLink');
        var helpButtonEl = document.getElementsByClassName('helpButton')[0];
        floatingLinkEl.style.display = 'none';
        helpButtonEl.style.display = 'none';

        // removes the overflow of body
        document.body.style.overflow = "hidden";
    }
    const showOverlappingElements = () => {
        var floatingLinkEl = document.getElementById('floatingLink');
        var helpButtonEl = document.getElementsByClassName('helpButton')[0];
        floatingLinkEl.style.display = 'flex';
        helpButtonEl.style.display = 'block';

        // revert the overflow of body
        document.body.style.overflow = "auto";
    }

    $('.searchIconButton').click((e) => {
        e.preventDefault();
        searchFormModal.classList.add("active");
        overlay.classList.add("active");

        hideOverlappingElements();
    })

    document.getElementById("searchModalClose").addEventListener("click", function (e) {
        searchFormModal.classList.remove("active");
        overlay.classList.remove("active");

        showOverlappingElements();
    });

    document.getElementById("searchModalFormOverlay").addEventListener("click", function (e) {
        searchFormModal.classList.remove("active");
        overlay.classList.remove("active");

        showOverlappingElements();
    });
})